import React from 'react'
import LeadTable from '../LeadTable'

const ViewerType2Dashboard = ({projectId}) => {
  return (
    <div
      style={{
        fontFamily: "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif",
        color: "#0F1B2A",
        minWidth: 0,
      }}
    >
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          height: 24,
          padding: "0 10px",
          marginBottom: 12,
          borderRadius: 999,
          background: "#F1F4F8",
          border: "1px solid #E4E9EF",
          fontFamily: "'IBM Plex Mono', ui-monospace, monospace",
          fontSize: 11,
          fontWeight: 600,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#5A6779",
        }}
      >
        vt2
      </span>
      <LeadTable projectId={projectId}/>
    </div>
  )
}

export default ViewerType2Dashboard
